import CookiesJS from 'cookies-js';
import templateImageUploaded from '../../../views/partials/formImageUploaded.handlebars';

export function initImagesUpload($, filesClient) {
    $('body').on('change', '.upload-images__input-files', async function () {
        try {
            const files = $(this).prop('files');
            $(this).parent().find('.preloader .bar').show();
            const {uploadedFiles} = await filesClient.uploadStatic(files, CookiesJS.get('auth_token'));
            uploadedFiles.forEach(uploadedFile => {
                $(this).parent().find('.array-items').append(templateImageUploaded({
                    image: {
                        key: uploadedFile.key,
                        href: uploadedFile.location,
                        uploading: true,
                    }
                })); 
            });

            feather.replace();
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
        $(this).parent().find('.preloader .bar').hide();
        // $(this).reset(); // TODO: fix me
    });
}
